import {useFormik} from 'formik'
import * as Yup from 'yup'
import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import {useLang} from '../../../../../_metronic/i18n/Metronici18n'
import {getAuth} from '../../../../modules/auth'
import {saveTopic} from '../../../../modules/auth/core/_requests'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'
import {KTSVG} from '../../../../../_metronic/helpers'

const profileDetailsSchema = Yup.object().shape({})

function AddSMRTopicModal({setAction}: any) {
  const lang = useLang()
  const token = getAuth()

  const initialValues = {
    name: '',
    description: '',
    command: '',
    icon: '',
    measurementUnit: '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      try {
        const {data} = await saveTopic(
          0,
          values.name,
          values.description,
          values.command,
          values.icon,
          values.measurementUnit,
          lang,
          String(token?.api_token)
        )
        formik.resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#createSMRTopic_modal')
        modal.hide()
        //
        SuccessfulNotify('Registration Successfully Added.')
        setAction(true)
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
      }
    },
  })

  return (
    <div className='modal fade' tabIndex={-1} id='createSMRTopic_modal'>
      <div className='modal-dialog '>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Create Unit</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                <div className='mb-10'>
                  <label className='form-label'>Name</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Name'
                    {...formik.getFieldProps('name')}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Description</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Description'
                    {...formik.getFieldProps('description')}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Command</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Command'
                    {...formik.getFieldProps('command')}
                  />
                </div>
                <div className='mb-10'>
                  <label className='form-label'>Icon</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Icon'
                    {...formik.getFieldProps('icon')}
                  />
                </div>
                <div className='mb-10'>
                  <label className='form-label'>Measurement Unit</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Measurement Unit'
                    {...formik.getFieldProps('measurementUnit')}
                  />
                </div>
                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Create Topic
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddSMRTopicModal
